import {
  Xtp,
  XtpSerialized,
  XtpOptions,
  XtpOptionsSerialized,
} from './xtp.types'

// eslint-disable-next-line import/prefer-default-export
export function checkXtpWasUpdatedWithErrors(errors: { xtp: string, xtpOptions: string, }): boolean {
  const errorsList = [
    errors.xtp,
    errors.xtpOptions
  ].filter((error: string) => error !== '');

  return errorsList.length === 1;
}

export function adaptXtpFromResponse(xtp: Xtp | XtpSerialized): Xtp {
  return {
    id: (xtp as Xtp).id || (xtp as XtpSerialized).id,
    lbId: (xtp as Xtp).lbId || (xtp as XtpSerialized).LBID,
    ipAddr: (xtp as Xtp).ipAddr || (xtp as XtpSerialized).IPADDR,
    owner: (xtp as Xtp).owner || (xtp as XtpSerialized).OWNER,
    access: (xtp as Xtp).access || (xtp as XtpSerialized).ACCESS,
    group: (xtp as Xtp).group || (xtp as XtpSerialized).GROUP,
  };
}

export function adaptXtpListFromResponse(xtps: Xtp[] | XtpSerialized[]): Xtp[] {
  return xtps.map(adaptXtpFromResponse);
}

export function adaptXtpOptionsFromResponse(data: XtpOptions | XtpOptionsSerialized): XtpOptions {
  return {
    bwAlmThreshHigh: (data as XtpOptions).bwAlmThreshHigh || (data as XtpOptionsSerialized).BWALMTHRESHHIGH,
    bwAlmThreshLow: (data as XtpOptions).bwAlmThreshLow || (data as XtpOptionsSerialized).BWALMTHRESHLOW,
    dbQueryIntvl: (data as XtpOptions).dbQueryIntvl || (data as XtpOptionsSerialized).DBQUERYINTVL,
    dbQueryTimeout: (data as XtpOptions).dbQueryTimeout || (data as XtpOptionsSerialized).DBQUERYTIMEOUT,
    droppedAlmInterval: (data as XtpOptions).droppedAlmInterval || (data as XtpOptionsSerialized).DROPPEDALMINTERVAL,
    dbSyncWaitTime: (data as XtpOptions).dbSyncWaitTime || (data as XtpOptionsSerialized).DBSYNCWAITTIME,
    id: (data as XtpOptions).id,
    ID: (data as XtpOptions).ID,
    rdrHeartBeatSecs: (data as XtpOptions).rdrHeartBeatSecs || (data as XtpOptionsSerialized).RDRHEARTBEATSECS,
    rdrhBtoClose: (data as XtpOptions).rdrhBtoClose || (data as XtpOptionsSerialized).RDRHBTOCLOSE,
    scdRouteAlgorithm: (data as XtpOptions).scdRouteAlgorithm || (data as XtpOptionsSerialized).SCDROUTEALGORITHM,
    smpReportInterval: (data as XtpOptions).smpReportInterval || (data as XtpOptionsSerialized).SMPREPORTINTERVAL,
    throttleUpdInterval: (data as XtpOptions).throttleUpdInterval || (data as XtpOptionsSerialized).THROTTLEUPDINTERVAL,
    wtrHeartBeatSecs: (data as XtpOptions).wtrHeartBeatSecs || (data as XtpOptionsSerialized).WTRHEARTBEATSECS,
    wtrReconnectSecs: (data as XtpOptions).wtrReconnectSecs || (data as XtpOptionsSerialized).WTRRECONNECTSECS,
  };
}

export function adaptXtpOptionsListFromResponse(xtps: XtpOptions[] | XtpOptionsSerialized[]): XtpOptions[] {
  return xtps.map(adaptXtpOptionsFromResponse);
}
